import { render, staticRenderFns } from "./LabelManage.vue?vue&type=template&id=da8a1282&scoped=true"
import script from "./LabelManage.vue?vue&type=script&lang=js"
export * from "./LabelManage.vue?vue&type=script&lang=js"
import style0 from "./LabelManage.vue?vue&type=style&index=0&id=da8a1282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8a1282",
  null
  
)

export default component.exports